import { BrowserRouter, Route, Routes } from "react-router-dom";
import HomeLayout from "./components/HomeLayout";
import ProtectedRoute from "./components/ProtectedRoute";
import { Container } from "@mui/material";
import WealthScapePage from "./pages/WealthScapePage";
import FinsensePage from "./pages/FinsensePage";
import HomePage from "./pages/HomePage";
import ConnectHubPage from "./pages/ConnectHubPage";
import PrismPage from "./pages/PrismPage";
import RiskGaugePage from "./pages/RiskGaugePage";
import ConsentJourneyPage from "./pages/ConsentJourneyPage";
import SimBanksPage from "./pages/SimBanksPage";
import LoginPage from "./pages/LoginPage";
import { AuthProvider } from "./contexts/AuthContext";

export default function App() {
  return (
    <Container disableGutters component="div" maxWidth={false}>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/" element={<ProtectedRoute><HomeLayout /></ProtectedRoute>}>
              <Route path="" element={<HomePage />} />
              <Route path="/connect-hub" element={<ConnectHubPage />} />
              <Route path="/wealth-scape" element={<WealthScapePage />} />
              <Route path="/finsense" element={<FinsensePage />} />
              <Route path="/prism" element={<PrismPage />} />
              <Route path="/risk-gauge" element={<RiskGaugePage />} />
              <Route path="/consent-journey" element={<ConsentJourneyPage />} />
              <Route path="/simbanks" element={<SimBanksPage />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </Container>
  );
}
